
const MenuSetPage = () => {
  return (
    <div>Menu set</div>
  )
};

export default MenuSetPage;
